// Utility functions for icon handling

export const getIconPath = (iconName, extension = 'png') => {
  if (!iconName) return '/icons/default.png';
  
  // Remove file extension if already present
  const cleanName = iconName.replace(/\.(png|jpg|jpeg|svg|gif)$/i, '');
  return `/icons/${cleanName}.${extension}`;
};

export const checkIconExists = async (iconPath) => {
  try {
    const response = await fetch(iconPath, { method: 'HEAD' });
    return response.ok;
  } catch (error) {
    console.warn(`Icon check failed for ${iconPath}:`, error);
    return false;
  }
};

export const preloadIcon = (iconPath) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load icon: ${iconPath}`));
    img.src = iconPath;
  });
};

export const getFallbackIcon = (iconName) => {
  // Map of common icon fallbacks
  const fallbacks = {
    'logo': '/icons/UsmaApp.png',
    'icon': '/icons/UsmaApp.png',
    'plus': '/icons/plus.png',
    'friends': '/icons/friends.png',
    'addFriend': '/icons/addFriend.png',
    'message': '/icons/message.png',
    'follow': '/icons/follow.png'
  };
  
  return fallbacks[iconName] || '/icons/default.png';
};

 